<div class="flex flex-col md:flex-row min-h-screen bg-white">
  <!-- Sidebar para desktop -->
  <app-sidebar
    [circleNumber]="4"
    (backClick)="goBack()"
    class="bg-teu-purple hidden sm:block relative w-full md:w-[197px] h-[120px] md:h-auto flex-shrink-0 overflow-hidden">
  </app-sidebar>

  <!-- Header para móvil -->
  <app-header [circleNumber]="4" (backClick)="goBack()"></app-header>

  <!-- Main Content -->
  <div class="flex-1 flex flex-col">
    <app-subheader [circleNumber]="4" class="pt-[60px] md:pt-0"></app-subheader>

    <!-- MOBILE: Navegación entre pantallas -->
    <div class="md:hidden">
      <!-- PANTALLA 1: Mis datos laborales -->
      <div *ngIf="currentStep === 'business-data'" class="flex-1 px-4 pb-12 max-w-[800px] mx-auto w-full">
        <h1 class="teu-title text-2xl mb-2 text-center">Mis datos laborales</h1>
        <p class="teu-subtitle text-lg mb-8 text-center">Completa tu información laboral</p>

        <!-- Formulario de datos laborales (componente reutilizable) -->
        <ng-container *ngTemplateOutlet="businessDataFormTpl; context: { isMobile: true }"></ng-container>

        <!-- Botón Confirmar Mobile -->
        <button
          type="button"
          class="btn-primary w-full max-w-[300px] h-[46px] mt-6 mx-auto"
          [class.opacity-50]="businessDataForm.invalid"
          [disabled]="businessDataForm.invalid"
          (click)="onSubmitBusinessData()">
          Confirmar
        </button>
      </div>

      <!-- PANTALLA 2: Domicilio de empresa -->
      <div *ngIf="currentStep === 'business-address'" class="flex-1 px-4 pb-12 max-w-[800px] mx-auto w-full">
        <h1 class="teu-title text-2xl mb-2 text-center">Domicilio de empresa</h1>
        <p class="teu-subtitle text-lg mb-8 text-center">Completa la dirección de tu empresa</p>

        <!-- Formulario de dirección de empresa (componente reutilizable) -->
        <ng-container *ngTemplateOutlet="businessAddressFormTpl; context: { isMobile: true }"></ng-container>

        <!-- Botón Confirmar Mobile -->
        <button
          type="button"
          class="btn-primary w-full max-w-[300px] h-[46px] mt-6 mx-auto"
          [class.opacity-50]="businessAddressForm.invalid"
          [disabled]="businessAddressForm.invalid"
          (click)="onSubmitBusinessAddress()">
          Confirmar
        </button>
      </div>
    </div>

    <!-- DESKTOP: Ambas secciones en filas -->
    <div class="hidden md:block px-[100px] pb-12 md:pb-20">
      <!-- FILA 1: Mis datos laborales -->
      <div class="max-w-[1200px] mx-auto mb-12">
        <h1 class="teu-title text-[32px] mb-4 text-center">Mis datos laborales</h1>
        <p class="teu-subtitle text-xl mb-12 text-center">Completa tu información laboral</p>

        <!-- Formulario de datos laborales (componente reutilizable) -->
        <ng-container *ngTemplateOutlet="businessDataFormTpl; context: { isMobile: false }"></ng-container>
      </div>

      <!-- FILA 2: Domicilio de empresa -->
      <div class="max-w-[1200px] mx-auto">
        <h1 class="teu-title text-[32px] mb-4 text-center">Domicilio de empresa</h1>
        <p class="teu-subtitle text-xl mb-12 text-center">Completa la dirección de tu empresa</p>

        <!-- Formulario de dirección de empresa (componente reutilizable) -->
        <ng-container *ngTemplateOutlet="businessAddressFormTpl; context: { isMobile: false }"></ng-container>

        <!-- Botón Confirmar Desktop -->
        <button
          type="button"
          class="btn-primary w-full max-w-[300px] h-[46px] mt-6 mx-auto"
          [class.opacity-50]="businessDataForm.invalid || businessAddressForm.invalid"
          [disabled]="businessDataForm.invalid || businessAddressForm.invalid"
          (click)="onSubmitFinalForm()">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- TEMPLATE: Formulario de datos laborales -->
<ng-template #businessDataFormTpl let-isMobile="isMobile">
  <form [formGroup]="businessDataForm" [class]="isMobile ? 'flex flex-col gap-4 max-w-[500px] mx-auto' : 'flex flex-col gap-4'">
    <!-- Primera fila de dropdowns -->
    <div [class]="isMobile ? 'flex flex-col gap-4' : 'grid grid-cols-3 gap-4'">
      <!-- Estudios completados -->
      <div class="relative">
        <p-dropdown
          formControlName="education"
          [options]="educationOptions"
          placeholder="Estudios completados"
          optionLabel="label"
          optionValue="value"
          class="w-full"
          [class.p-invalid]="isFieldInvalid(businessDataForm, 'education')">
        </p-dropdown>
        <small class="p-error" *ngIf="isFieldInvalid(businessDataForm, 'education')">
          {{ getFieldError(businessDataForm, 'education') }}
        </small>
      </div>

      <!-- Situación Laboral Actual -->
      <div class="relative">
        <p-dropdown
          formControlName="employmentStatus"
          [options]="employmentStatusOptions"
          placeholder="Situación Laboral Actual"
          optionLabel="label"
          optionValue="value"
          class="w-full"
          [class.p-invalid]="isFieldInvalid(businessDataForm, 'employmentStatus')">
        </p-dropdown>
        <small class="p-error" *ngIf="isFieldInvalid(businessDataForm, 'employmentStatus')">
          {{ getFieldError(businessDataForm, 'employmentStatus') }}
        </small>
      </div>

      <!-- Actividad Económica -->
      <div class="relative">
        <p-dropdown
          formControlName="economicActivity"
          [options]="economicActivityOptions"
          placeholder="Actividad Económica"
          optionLabel="label"
          optionValue="value"
          class="w-full"
          [filter]="true"
          filterBy="label"
          [class.p-invalid]="isFieldInvalid(businessDataForm, 'economicActivity')">
        </p-dropdown>
        <small class="p-error" *ngIf="isFieldInvalid(businessDataForm, 'economicActivity')">
          {{ getFieldError(businessDataForm, 'economicActivity') }}
        </small>
      </div>
    </div>

    <!-- Segunda fila de dropdowns -->
    <div [class]="isMobile ? 'flex flex-col gap-4' : 'grid grid-cols-3 gap-4'">
      <!-- Especificación de actividad -->
      <div class="relative">
        <p-dropdown
          formControlName="activitySpecification"
          [options]="activitySpecificationOptions"
          placeholder="Especificación de actividad"
          optionLabel="label"
          optionValue="value"
          class="w-full"
          [filter]="true"
          filterBy="label"
          [disabled]="!businessDataForm.get('economicActivity')?.value">
        </p-dropdown>
      </div>

      <!-- Giro de la empresa -->
      <div class="relative">
        <p-dropdown
          formControlName="companyType"
          [options]="companyTypeOptions"
          placeholder="Giro de la empresa"
          optionLabel="label"
          optionValue="value"
          class="w-full"
          [filter]="true"
          filterBy="label"
          [class.p-invalid]="isFieldInvalid(businessDataForm, 'companyType')">
        </p-dropdown>
        <small class="p-error" *ngIf="isFieldInvalid(businessDataForm, 'companyType')">
          {{ getFieldError(businessDataForm, 'companyType') }}
        </small>
      </div>

      <!-- Actividad Económica (segunda instancia) -->
      <div class="relative">
        <p-dropdown
          formControlName="secondaryActivity"
          [options]="economicActivityOptions"
          placeholder="Actividad Económica"
          optionLabel="label"
          optionValue="value"
          class="w-full"
          [filter]="true"
          filterBy="label">
        </p-dropdown>
      </div>
    </div>

    <!-- Descripción de Actividad -->
    <div class="relative">
      <label class="block font-inter text-sm font-normal leading-[140%] text-black mb-2">
        Descripción de Actividad <span class="text-xs text-gray-500">(Agrega una breve descripción de tu trabajo)</span>
      </label>
      <textarea
        pInputText
        formControlName="activityDescription"
        placeholder="Describe tu actividad laboral..."
        class="w-full min-h-[80px] resize-none"
        [class.p-invalid]="isFieldInvalid(businessDataForm, 'activityDescription')"
        maxlength="200"
        rows="3">
      </textarea>
      <small class="p-error" *ngIf="isFieldInvalid(businessDataForm, 'activityDescription')">
        {{ getFieldError(businessDataForm, 'activityDescription') }}
      </small>
    </div>

    <!-- Tercera fila: Ingresos y gastos -->
    <div [class]="isMobile ? 'flex flex-col gap-4' : 'grid grid-cols-3 gap-4'">
      <!-- ¿Con qué frecuencia recibes tus ingresos? -->
      <div class="relative">
        <label class="block font-inter text-sm font-normal leading-[140%] text-black mb-2">
          ¿Con qué frecuencia recibes tus ingresos?
        </label>
        <p-dropdown
          formControlName="incomeFrequency"
          [options]="incomeFrequencyOptions"
          placeholder="Semanal"
          optionLabel="label"
          optionValue="value"
          class="w-full"
          [class.p-invalid]="isFieldInvalid(businessDataForm, 'incomeFrequency')">
        </p-dropdown>
        <small class="p-error" *ngIf="isFieldInvalid(businessDataForm, 'incomeFrequency')">
          {{ getFieldError(businessDataForm, 'incomeFrequency') }}
        </small>
      </div>

      <!-- ¿Cuál es tu ingreso mensual neto? -->
      <div class="relative">
        <label class="block font-inter text-sm font-normal leading-[140%] text-black mb-2">
          ¿Cuál es tu ingreso mensual neto?
        </label>
        <div class="relative">
          <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 font-medium" style="z-index: 10;">$</span>
          <input
            pInputText
            type="text"
            formControlName="monthlyIncome"
            placeholder="0"
            class="w-full"
            [class.p-invalid]="isFieldInvalid(businessDataForm, 'monthlyIncome')"
            style="padding-left: 2rem !important;"
            (input)="formatCurrency($event, 'monthlyIncome')"
            (keypress)="onlyNumbers($event)" />
        </div>
        <small class="p-error" *ngIf="isFieldInvalid(businessDataForm, 'monthlyIncome')">
          {{ getFieldError(businessDataForm, 'monthlyIncome') }}
        </small>
      </div>

      <!-- ¿Cuáles son tus gastos mensuales? -->
      <div class="relative">
        <label class="block font-inter text-sm font-normal leading-[140%] text-black mb-2">
          ¿Cuáles son tus gastos mensuales?
        </label>
        <div class="relative">
          <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 font-medium" style="z-index: 10;">$</span>
          <input
            pInputText
            type="text"
            formControlName="monthlyExpenses"
            placeholder="0"
            class="w-full"
            [class.p-invalid]="isFieldInvalid(businessDataForm, 'monthlyExpenses')"
            style="padding-left: 2rem !important;"
            (input)="formatCurrency($event, 'monthlyExpenses')"
            (keypress)="onlyNumbers($event)" />
        </div>
        <small class="p-error" *ngIf="isFieldInvalid(businessDataForm, 'monthlyExpenses')">
          {{ getFieldError(businessDataForm, 'monthlyExpenses') }}
        </small>
      </div>
    </div>

    <!-- Cuarta fila -->
    <div [class]="isMobile ? 'flex flex-col gap-4' : 'grid grid-cols-3 gap-4'">
      <!-- Antigüedad de este empleo -->
      <div class="relative">
        <p-dropdown
          formControlName="jobSeniority"
          [options]="jobSeniorityOptions"
          placeholder="Antigüedad de este empleo"
          optionLabel="label"
          optionValue="value"
          class="w-full"
          [class.p-invalid]="isFieldInvalid(businessDataForm, 'jobSeniority')">
        </p-dropdown>
        <small class="p-error" *ngIf="isFieldInvalid(businessDataForm, 'jobSeniority')">
          {{ getFieldError(businessDataForm, 'jobSeniority') }}
        </small>
      </div>

      <!-- Dependientes económicos -->
      <div class="relative">
        <p-dropdown
          formControlName="economicDependents"
          [options]="economicDependentsOptions"
          placeholder="Dependientes económicos"
          optionLabel="label"
          optionValue="value"
          class="w-full"
          [class.p-invalid]="isFieldInvalid(businessDataForm, 'economicDependents')">
        </p-dropdown>
        <small class="p-error" *ngIf="isFieldInvalid(businessDataForm, 'economicDependents')">
          {{ getFieldError(businessDataForm, 'economicDependents') }}
        </small>
      </div>

      <!-- Teléfono y Extensión -->
      <div class="flex gap-3">
        <div class="flex-[3] relative">
          <input
            pInputText
            type="text"
            formControlName="companyPhone"
            placeholder="Teléfono de la empresa"
            class="w-full"
            [class.p-invalid]="isFieldInvalid(businessDataForm, 'companyPhone')"
            maxlength="10"
            (keypress)="onlyNumbers($event)" />
          <small class="p-error" *ngIf="isFieldInvalid(businessDataForm, 'companyPhone')">
            {{ getFieldError(businessDataForm, 'companyPhone') }}
          </small>
        </div>
        <input
          pInputText
          type="text"
          formControlName="extension"
          placeholder="Ext"
          class="flex-[1]"
          maxlength="5"
          (keypress)="onlyNumbers($event)" />
      </div>
    </div>

    <!-- Quinta fila: Jefe inmediato -->
    <div class="relative">
      <p-dropdown
        formControlName="immediateBoss"
        [options]="immediateBossOptions"
        placeholder="Jefe inmediato"
        optionLabel="label"
        optionValue="value"
        class="w-full"
        [class.p-invalid]="isFieldInvalid(businessDataForm, 'immediateBoss')">
      </p-dropdown>
      <small class="p-error" *ngIf="isFieldInvalid(businessDataForm, 'immediateBoss')">
        {{ getFieldError(businessDataForm, 'immediateBoss') }}
      </small>
    </div>
  </form>
</ng-template>

<!-- TEMPLATE: Formulario de dirección de empresa -->
<ng-template #businessAddressFormTpl let-isMobile="isMobile">
  <form [formGroup]="businessAddressForm" [class]="isMobile ? 'flex flex-col gap-4 max-w-[500px] mx-auto' : 'flex flex-col gap-4'">
    <!-- Checkbox: Mi domicilio personal es el mismo que el de la empresa -->
    <div [class]="isMobile ? 'flex items-center gap-3 p-4 bg-blue-50 rounded-lg border border-blue-200' : 'flex items-center gap-3 p-4 bg-blue-50 rounded-lg border border-blue-200 max-w-[800px] mx-auto'">
      <p-checkbox formControlName="sameAsPersonal" [binary]="true" class="text-blue-600"></p-checkbox>
      <label class="font-inter text-sm font-normal leading-[140%] text-black cursor-pointer">
        Mi domicilio personal es el mismo que el de la empresa
      </label>
    </div>

    <!-- Dirección de la empresa (solo si no es el mismo domicilio) -->
    <div *ngIf="!businessAddressForm.get('sameAsPersonal')?.value" [class]="isMobile ? 'w-full' : 'max-w-[1200px] mx-auto w-full'">
      <label class="block font-inter text-sm font-normal leading-[140%] text-black mb-4">
        Dirección de la empresa
      </label>

      <!-- Primera fila: Calle -->
      <div class="relative mb-4">
        <input
          pInputText
          type="text"
          formControlName="street"
          placeholder="Calle"
          class="w-full"
          [class.p-invalid]="isFieldInvalid(businessAddressForm, 'street')" />
        <small class="p-error" *ngIf="isFieldInvalid(businessAddressForm, 'street')">
          {{ getFieldError(businessAddressForm, 'street') }}
        </small>
      </div>

      <!-- Segunda fila: No.Exterior, No.Interior, Código Postal -->
      <div [class]="isMobile ? 'flex flex-col gap-4 mb-4' : 'grid grid-cols-3 gap-3 mb-4'">
        <div class="relative">
          <input
            pInputText
            type="text"
            formControlName="exteriorNumber"
            placeholder="No.Exterior"
            class="w-full"
            [class.p-invalid]="isFieldInvalid(businessAddressForm, 'exteriorNumber')" />
          <small class="p-error" *ngIf="isFieldInvalid(businessAddressForm, 'exteriorNumber')">
            {{ getFieldError(businessAddressForm, 'exteriorNumber') }}
          </small>
        </div>
        <input
          pInputText
          type="text"
          formControlName="interiorNumber"
          placeholder="No.Interior"
          class="w-full" />
        <div class="relative">
          <input
            pInputText
            type="text"
            formControlName="postalCode"
            placeholder="Código Postal"
            class="w-full"
            [class.p-invalid]="isFieldInvalid(businessAddressForm, 'postalCode')"
            maxlength="5"
            (input)="onPostalCodeChange($event)"
            (keypress)="onlyNumbers($event)" />
          <small class="p-error" *ngIf="isFieldInvalid(businessAddressForm, 'postalCode')">
            {{ getFieldError(businessAddressForm, 'postalCode') }}
          </small>
        </div>
      </div>

      <!-- Tercera fila: Colonia, Delegación/Municipio, Estado -->
      <div [class]="isMobile ? 'flex flex-col gap-4 mb-4' : 'grid grid-cols-3 gap-3 mb-4'">
        <div class="relative">
          <p-dropdown
            formControlName="colony"
            [options]="colonyOptions"
            placeholder="Colonia"
            optionLabel="label"
            optionValue="value"
            class="w-full"
            [filter]="true"
            filterBy="label"
            [disabled]="!businessAddressForm.get('postalCode')?.value"
            [class.p-invalid]="isFieldInvalid(businessAddressForm, 'colony')">
          </p-dropdown>
          <small class="p-error" *ngIf="isFieldInvalid(businessAddressForm, 'colony')">
            {{ getFieldError(businessAddressForm, 'colony') }}
          </small>
        </div>

        <div class="relative">
          <p-dropdown
            formControlName="municipality"
            [options]="municipalityOptions"
            placeholder="Delegación/Municipio"
            optionLabel="label"
            optionValue="value"
            class="w-full"
            [filter]="true"
            filterBy="label"
            [disabled]="!businessAddressForm.get('postalCode')?.value"
            [class.p-invalid]="isFieldInvalid(businessAddressForm, 'municipality')">
          </p-dropdown>
          <small class="p-error" *ngIf="isFieldInvalid(businessAddressForm, 'municipality')">
            {{ getFieldError(businessAddressForm, 'municipality') }}
          </small>
        </div>

        <input
          pInputText
          type="text"
          formControlName="state"
          placeholder="Estado"
          class="w-full"
          readonly />
      </div>
    </div>
  </form>
</ng-template>
